export class NotFound {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const container = document.getElementById(this.containerId);
        if (!container) return;

        container.innerHTML = `
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 60vh; text-align: center; padding: 20px;">
                <div style="font-size: 6rem; margin-bottom: 1rem;">😕</div>
                <h1 style="font-size: 2.5rem; color: #333; margin-bottom: 0.5rem;">404 - Page Not Found</h1>
                <p style="color: #666; font-size: 1.1rem; margin-bottom: 2rem; max-width: 400px;">
                    Oops! The page you are looking for seems to have wandered off the pitch.
                </p>
                <button class="fg-btn fg-btn--primary" id="not-found-home-btn" style="max-width: 200px;">
                    Return Home
                </button>
            </div>
        `;

        container.querySelector('#not-found-home-btn')?.addEventListener('click', () => {
            if (window.app) window.app.handleNavigation('home');
        });
    }
}